import * as StatisticsService from '../services/StatisticsService'
import * as MockedStatisticsService from '../services/MockedStatisticsService'
import { isRole, isLicense } from './users'
import { userPrimaryRoles, licenses } from './constants'

export const getStatisticsService = userInfo =>
  isRole(userInfo.primaryRoles, userPrimaryRoles.trial) || isLicense(userInfo, licenses.freemium) ? MockedStatisticsService : StatisticsService
